import h5Login from "@hb/h5-login";
import { ENV, UserInfo } from "@hb/h5-login/dist/src/model";
import { getSystemCode, getAppEnv } from "./env/env";
import "../style/VantCustomStyle.css";
import "../style/CommonStyle.css";
import { getQueryString } from "./utils/commonTools";
import { transformToCategoryId } from "./constants/commonConstants";
import { storeMgr } from "./storeMgr";
import logger from "./utils/logger";
import { loginManager } from "./auth/loginManager";

export class AppMgr {
  get pageFrom() {
    const from = String(getQueryString("from"));

    if (from === "1") {
      return "钱包页";
    }

    if (from === "2") {
      return "我的优惠券页";
    }

    if (from === "0") {
      return "首页";
    }

    return from;
  }

  async loginInit() {
    h5Login.initConfig({
      env: getAppEnv() as ENV,
      systemCode: getSystemCode(),
      // 是否开启日志开关
      debug: process.env.VUE_APP_ENV !== "pro",
    });

    const isLoggedIn = await loginManager.checkLoginStatus();
    if (isLoggedIn) {
      storeMgr.userInfo = h5Login.userInfo as UserInfo;
    } else {
      const loginResult = await loginManager.signIn({
        forceRefresh: true,
      });
      if (loginResult.success && loginResult.userInfo) {
        storeMgr.userInfo = loginResult.userInfo;
      }
    }
  }

  async login() {
    try {
      // 使用统一的登录管理器
      await storeMgr.store.dispatch("user/actionRequestUserInfo");
    } catch (error) {
      logger("登录失败:", error);
      // 登录失败时的处理可以在这里添加
    }
  }

  async relogin() {
    try {
      // eslint-disable-next-line no-console
      console.log("[appMgr] relogin method called - starting relogin process");

      // 使用统一的登录管理器进行重新登录
      storeMgr.store.dispatch("user/actionRelogin");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("[appMgr] relogin failed:", error);
      logger("重新登录失败:", error);
      // 重新登录失败时的处理可以在这里添加
    }
  }

  async logout() {
    try {
      // 使用统一的登录管理器进行登出
      await storeMgr.store.dispatch("user/actionLogout");
      // 重置 storeMgr 中的用户信息
      storeMgr.resetUserInfo();
    } catch (error) {
      logger("登出失败:", error);
    }
  }

  get pageCategory() {
    const businessType = getQueryString("businessType");
    return transformToCategoryId(businessType);
  }
}

/** app管理器 */
export const appMgr = new AppMgr();
